"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { BookmarkPlus } from "lucide-react";
import { useAddToWatchlist, useIsInWatchlist } from "@/queries/watchlist";
interface Props {
  title: string;
  title_en?: string;
  logo?: string;
  uuid?: string;
  isbook?: boolean;
}
export default function MovieHeader(t0) {
  const $ = _c(24);
  const {
    title,
    title_en,
    uuid,
    logo,
    isbook
  } = t0;
  const {
    data,
    mutate
  } = useAddToWatchlist();
  const inWatchlist = useIsInWatchlist(uuid);
  const isBookmarked = inWatchlist || isbook || Boolean(data?.data?.created_at);
  let t1;
  if ($[0] !== mutate || $[1] !== uuid) {
    t1 = () => {
      if (!uuid) {
        return;
      }
      mutate({
        content_type: "series",
        content_uuid: uuid
      });
    };
    $[0] = mutate;
    $[1] = uuid;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleAdd = t1;
  let t2;
  if ($[3] !== logo || $[4] !== title) {
    t2 = logo && <div className="relative w-36 sm:w-44 lg:w-48 h-auto"><Image src={logo} alt={title} width={192} height={96} className="h-auto w-full object-contain" sizes="192px" priority={true} /></div>;
    $[3] = logo;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== title_en) {
    t3 = <h1 className="text-xl sm:text-2xl lg:text-4xl font-extrabold leading-snug">{title_en}</h1>;
    $[6] = title_en;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = `w-[22px] h-[22px] md:w-8 md:h-8 ${isBookmarked ? "text-primary" : "text-white"}`;
  let t5;
  if ($[8] !== t4) {
    t5 = <BookmarkPlus className={t4} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleAdd || $[11] !== t5) {
    t6 = <div onClick={handleAdd} className="flex items-center justify-center cursor-pointer ms-3 mb-1">{t5}</div>;
    $[10] = handleAdd;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <div className="flex items-center">{t3}{t6}</div>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== title) {
    t8 = <h2 className="text-sm sm:text-md lg:text-xl text-gray-400 font-bold leading-snug">{title}</h2>;
    $[16] = title;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div className="flex justify-center flex-col">{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t2 || $[22] !== t9) {
    t10 = <div className="flex flex-col gap-4 sm:gap-6">{t2}{t9}</div>;
    $[21] = t2;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}